// import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import DynamicModal from '../model/DynamicModel';
import apiProvider from '../apiProvider/api';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';

const CoursePageLayer = () => {
    const [categories, setCategories] = useState([]);
    const [locations, setLocations] = useState([]);

    const [isEditMode, setIsEditMode] = useState(false);
    const [isClassroom, setIsClassroom] = useState(false);

    const [curriculamForm, setCurriculamForm] = useState({
        name: "", serial: ""
    })
    const navigate = useNavigate();

    const [errors, setErrors] = useState({});
    const [curriculamData, setCurriculamData] = useState([]);
    const [reviewData, setReviewData] = useState([]);
    const [getId, setGetId] = useState(localStorage.getItem("getCourseId") ?? "");
    const location = useLocation();
    const { editDatas } = location.state || {};

    const [courseId, setCourseId] = useState("")

    const [currentStep, setCurrentStep] = useState(1);
    const quillRef = useRef(null);
    const [isHighlightReady, setIsHighlightReady] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [getSubtitle, setgetSubtitle] = useState();

    const [selectedCategory, setSelectedCategory] = useState(null);

    const [formData, setFormData] = useState({
        categoryType: '',
        courseName: '',
        InstructorName: '',
        language: 'English',
        offerPrice: '',
        price: '',
        shortDescription: '',
        description: '',
        feedback: '',
        slug: '',
        location: "",
        schedules: [{ date: '', duration: '' }],
        hasEarlyBirdDiscount: false,
        discountType: 'percentage',
        discountValue: '',
        // discountEndDate: '',
    });


    const handleEditClick = (item) => {
        setIsEditMode(true)
        setSelectedItem(item);
        // console.log(item, "item");

        setCurriculamForm({ name: item.tittle, serial: item.serial, id: item.id });
    };

    const handleDeleteCurri = async (course) => {
        console.log(course, "ccccccccc");

        Swal.fire({
            title: 'Are you sure?',
            text: `You are about to delete "${course.title}"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            customClass: {
                title: 'swal-title-small',
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                // 👇 Call your delete API or logic here
                const result = await apiProvider.deletCurri(course.id);
                console.log(result, "rrrrrrrrrrrr");
                if (result) {
                    deleteCategory(course.id);
                }



            }
        });
    };

    // Example delete function (you should replace this with your actual API call)
    const deleteCategory = async (id) => {
        try {
            // await your API delete call
            console.log("Deleting Curriculam with ID:", id);

            Swal.fire(
                'Deleted!',
                'Curriculam has been deleted.',
                'success'
            );
            // Refresh data
            fetchCurriculum();

            // Optionally refresh the list or update UI
        } catch (error) {
            Swal.fire(
                'Error!',
                'There was a problem deleting the category.',
                'error'
            );
        }
    };

    const handleChangeForModul = (e) => {
        const { name, value } = e.target;
        setCurriculamForm((prev) => ({ ...prev, [name]: value }));
    };

    const nextStep = () => {
        setCurrentStep(currentStep + 1);
    };

    const navagatoFun = () => {
        navigate(`/course`)
    };

    const prevStep = () => {
        setCurrentStep(currentStep - 1);
    };

    const handleChange = (e) => {
        // console.log("enetr halchangeee");

        const { name, value, type, files } = e.target;

        setFormData({
            ...formData,
            [name]: type === 'file' ? files[0] : value
        });
        if (name === "categoryType") {
            const selectedCategory = categories.find(cat => String(cat.id) === value);

            if (selectedCategory) {
                setIsClassroom(selectedCategory.categoryType === "1");
            } else {
                setIsClassroom(false);
                formData.location = ""
            }
        }
        // Update form data
        const updatedFormData = {
            ...formData,
            [name]: value
        };

        // discount

        if (
            updatedFormData.hasEarlyBirdDiscount &&
            updatedFormData.price &&
            updatedFormData.discountValue
        ) {
            updatedFormData.offerPrice =
                updatedFormData.discountType === 'percentage'
                    ? (updatedFormData.price - (updatedFormData.price * updatedFormData.discountValue / 100)).toFixed(2)
                    : (updatedFormData.price - updatedFormData.discountValue).toFixed(2);
        }

        setFormData(updatedFormData);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');     // Ensures 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // JS months are 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleSubmit = async (e) => {
        // const newErrors = {};
        // if (!formData.categoryType) newErrors.categoryType = 'Category is required';
        // if (!formData.courseName) newErrors.courseName = 'Course name is required';
        // // if (!formData.InstructorName) newErrors.InstructorName = 'Instructor name is required';
        // // if (!formData.language) newErrors.language = 'Language is required';
        // if (!formData.price) newErrors.price = 'Price is required';
        // // if (!formData.offerPrice) newErrors.offerPrice = 'Offer price is required';
        // if (!formData.shortDescription) newErrors.shortDescription = 'Short description is required';
        // // if (!formData.slug) newErrors.slug = 'Slug is required';
        // if (!formData.description) newErrors.description = 'Description is required';

        // // setErrors(newErrors);
        // if (Object.keys(newErrors).length > 0) {
        //     setErrors(newErrors);
        //     return;
        // }       
        // e.preventDefault();
        // console.log("Form submitted:", formData, "isEditMode", isEditMode);

        console.log(formData, "formData---");

        // return

        // profile.courseDate = courseDate ?? []
        const input = new FormData();
        input.append("categoryId", formData.categoryType);
        input.append("courseName", formData.courseName);
        input.append("InstructorName", formData.InstructorName);
        input.append("language", formData.language);
        input.append("offerPrice", formData.offerPrice);
        input.append("price", formData.price);
        input.append("shortDescription", formData.shortDescription);
        input.append("description", formData.description);
        input.append("slug", formData.slug);
        input.append("location", formData.location);
        input.append("hasEarlyBirdDiscount", formData.hasEarlyBirdDiscount);
        input.append("discountType", formData.discountType);
        input.append("discountValue", formData.discountValue);

        // hasEarlyBirdDiscount: false,
        // discountType: 'percentage',
        // discountValue: '',
        // Format dates in schedules
        const formattedSchedules = formData.schedules.map(schedule => ({
            date: formatDate(schedule.date), // "18 Apr, 2025"
            duration: schedule.duration
        }));

        // Append to FormData
        input.append("courseDate", JSON.stringify(formattedSchedules));



        // console.log(...input, "input");
        // return false

        try {
            let response;
            if (isEditMode) {
                // For edit mode, include the ID and use update endpoint
                input.append("id", formData.id);
                response = await apiProvider.updateCourse(input);
            } else {
                // For create mode
                if (formData.courseName) {
                    response = await apiProvider.addCourse(input);
                }
            }

            console.log(response, "response-g");

            if (response) {
                console.log("enter submit--------------fun");

                let editDataId = response.response.data.data.id || response.response.data.data.userEditId
                localStorage.setItem("getCourseId", editDataId)
                toast(response.response.data.message)
                setGetId(editDataId)
                // Reset form
                // setFormData({
                //     categoryType: "1", // Changed from "online" to "1" to match your select values
                //     categoryName: "",
                //     categoryStatus: "Active", // Changed to lowercase to match your select values
                //     categorySlug: "",
                //     categoryImage: ""
                // });

                // Refresh data
                fetchCurriculum();

                // Reset edit mode
                // setIsEditMode(false);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            // You might want to add error handling here (show toast, etc.)
        }
        // Add your form submission logic here
    };

    const handleCurriculamSubmit = async (e) => {
        // e.preventDefault();
        // console.log("Form submitted:", curriculamForm);

        const input = new FormData();
        input.append("courseId", getId);
        input.append("tittle", curriculamForm.name);
        input.append("serial", curriculamForm.serial);
        input.append("subTittle", curriculamForm.subTittle);

        // console.log(...input, "input");

        try {
            let response;
            if (isEditMode) {
                // For edit mode, include the ID and use update endpoint
                input.append("id", curriculamForm.id);
                response = await apiProvider.updateCurriculam(input);
            } else {
                // For create mode
                response = await apiProvider.addCurriculam(input);
            }

            console.log(response, "response-curi");

            if (response) {
                toast(response.response.data.message)

                // Refresh data
                // fetchCategories();
                fetchCurriculum();

                // Reset edit mode
                // setIsEditMode(false);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            // You might want to add error handling here (show toast, etc.)
        }
        // Add your form submission logic here
    }


    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);

    const fetchCategories = async () => {
        // console.log("enetr ffffffffff");

        try {
            const categoryResult = await apiProvider.getCategory();
            if (categoryResult?.response?.data?.data) {
                const updatedCategories = categoryResult.response.data.data.map(ival => ({
                    ...ival,
                    categoryName: `${ival.categoryName} / ${ival.categoryType === "1" ? "Online" : "Offline"}`
                }));
                setCategories(updatedCategories);
            }
            const locationResult = await apiProvider.getLocations();
            if (locationResult?.response?.data?.data) {
                const updatedLocations = locationResult.response.data.data
                setLocations(updatedLocations);
            }

        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchCurriculum = async () => {
        try {
            const curriculumResult = await apiProvider.getCurriculam();
            if (curriculumResult?.response?.data?.data) {
                // console.log(curriculumResult.response.data.data, "curriculum data", getId, "getId");

                // Filter curriculum based on courseId
                const filteredData = curriculumResult.response.data.data.filter(ival => ival.courseId == getId);
                setCurriculamData(filteredData);
                // console.log(filteredData, "filteredData");

                // Prepare subtitles
                const subtitles = filteredData.map(ival => ({
                    name: ival.subTittle,
                    value: ival.id,
                    courseId: ival.courseId,
                }));

                setgetSubtitle(subtitles);
            }

            const reviewResult = await apiProvider.getReview();
            console.log(reviewResult, "reviewResult");

            if (reviewResult?.response?.data?.data) {
                const filteredReviewData = reviewResult.response.data.data.filter(ival => ival.courseId == getId);
                console.log(filteredReviewData, "filteredReviewData- revieww");
                setReviewData(filteredReviewData);
            }
        } catch (error) {
            console.error('Error fetching curriculum:', error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    useEffect(() => {
        if (getId) {
            fetchCurriculum();
        }
    }, [getId]);
    // eslint-disable-next-line no-unused-vars
    const handleSave = () => {
        const editorContent = quillRef.current.getEditor().root.innerHTML;
        // console.log("Editor content:", editorContent);
    };

    const handleRichTextChange = useCallback((value) => {
        setFormData((prev) => ({
            ...prev,
            description: value, // Update description field
        }))
    }, [])

    // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
    const modules = isHighlightReady
        ? {
            syntax: {
                highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
            },
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        }
        : {
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        };

    const formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "header",
        "blockquote",
        "code-block",
        "list",
        "indent",
        "direction",
        "align",
        "link",
        "image",
        "video",
        "formula",
    ];

    useEffect(() => {
        console.log(editDatas, "schedules-edit");

        if (!editDatas) return;
        setIsEditMode(true)

        const parseDisplayDate = (displayDate) => {
            // Handle both "30 Apr, 2025" and "29-04-2025" formats
            if (displayDate.includes(',')) {
                // Format: "30 Apr, 2025"
                const [day, month, year] = displayDate.split(/[\s,]+/);
                const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(month);
                return `${year}-${String(monthIndex + 1).padStart(2, '0')}-${day.padStart(2, '0')}`;
            } else {
                // Format: "29-04-2025" (DD-MM-YYYY)
                const [day, month, year] = displayDate.split('-');
                return `${year}-${month}-${day}`;
            }
        };
        // console.log(editDatas, "editDatas-props function");
        // return false
        setFormData({
            courseName: editDatas.courseName || '',
            // categoryType: (editDatas.categoryName || '') + " / " + (editDatas.categoryType || ''),
            categoryType: editDatas.categoryId,
            InstructorName: editDatas.instructorName || '',
            language: 'English',
            offerPrice: editDatas.offerPrice || '',
            price: editDatas.price || '',
            shortDescription: editDatas.shortDescription || '',
            description: editDatas.description || '',
            slug: editDatas.course_slug || '',
            id: editDatas.id || null,
            location: editDatas.location || '',
            schedules: editDatas.courseDate && editDatas.courseDate.length ? editDatas.courseDate.map(s => ({
                date: parseDisplayDate(s.date), // Correctly converts "30 Apr, 2025" to "2025-04-30"
                duration: s.duration
            })) : [{ date: '', duration: '' }],
            hasEarlyBirdDiscount: editDatas.hasEarlyBirdDiscount || '',
            discountType: editDatas.discountType || null,
            discountValue: editDatas.discountValue || '',
        });
    }, []);

    // Function to handle status change
    const handleStatusChange = async (id, newStatus) => {
        const input = new FormData();
        input.append("id", id);
        input.append("status", newStatus);

        // console.log(...input, "input");

        try {
            let response = await apiProvider.reviewUpdate(input);

            console.log(response, "response-review");

            if (response) {
                toast(response.response.data.message)

                // Refresh data
                // fetchCategories();
                fetchCurriculum();
                navigate(`/course`)

                // Reset edit mode
                // setIsEditMode(false);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            // You might want to add error handling here (show toast, etc.)
        }
    };

    // console.log(editDatas, "editDatas");
    const handleScheduleChange = (index, field, value) => {
        const updatedSchedules = [...formData.schedules];
        updatedSchedules[index][field] = value;
        setFormData({
            ...formData,
            schedules: updatedSchedules
        });
    };

    // Add more schedule
    const addMoreSchedule = () => {
        setFormData({
            ...formData,
            schedules: [...formData.schedules, { date: '', duration: '' }]
        });
    };

    // Remove schedule
    const removeSchedule = (index) => {
        const updatedSchedules = formData.schedules.filter((_, i) => i !== index);
        setFormData({
            ...formData,
            schedules: updatedSchedules
        });
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-end">
                <div className='col-md-12'>
                    <div className='card-body'>
                        <h6 className='mb-4 text-xl'>{isEditMode ? "Edit course" : "Add Course"}</h6>
                        <p className='text-neutral-500'>
                            Fill up your details and proceed next steps.
                        </p>
                        {/* Form Wizard Start */}
                        <div className='form-wizard'>
                            <div >
                                <div className='form-wizard-header overflow-x-auto scroll-sm pb-8 my-32'>
                                    <ul className='list-unstyled form-wizard-list'>
                                        <li
                                            className={`form-wizard-list__item
                      ${[2, 3, 4].includes(currentStep) && "activated"}
                    ${currentStep === 1 && "active"} `}
                                        >
                                            <div className='form-wizard-list__line'>
                                                <span className='count'>1</span>
                                            </div>
                                            <span className='text text-xs fw-semibold'>
                                                Basic Information
                                            </span>
                                        </li>
                                        <li
                                            className={`form-wizard-list__item
                      ${[3, 4, 5].includes(currentStep) && "activated"}
                    ${currentStep === 2 && "active"} `}
                                        >
                                            <div className='form-wizard-list__line'>
                                                <span className='count'>2</span>
                                            </div>
                                            <span className='text text-xs fw-semibold'>
                                                Curriculum
                                            </span>
                                        </li>
                                        {editDatas &&
                                            <li
                                                className={`form-wizard-list__item
                                                    ${[3, 4].includes(currentStep) && "activated"}
                                                  ${currentStep === 3 && "active"} `}
                                            >
                                                <div className='form-wizard-list__line'>
                                                    <span className='count'>3</span>
                                                </div>
                                                <span className='text text-xs fw-semibold'>Review</span>
                                            </li>
                                        }
                                    </ul>
                                </div>
                                <fieldset
                                    className={`wizard-fieldset ${currentStep === 1 && "show"} `}
                                >
                                    <h6 className='text-md text-neutral-500'>
                                        Basic Information
                                    </h6>
                                    <div className='row gy-3'>
                                        <div className='col-sm-6'>
                                            <label className='form-label'>Select Category Name*</label>
                                            <div className='position-relative'>
                                                <select
                                                    className="form-select"
                                                    name="categoryType"
                                                    value={formData.categoryType}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select a category</option>
                                                    {categories.map((category) => (
                                                        <option key={category.id} value={category.id}>
                                                            {category.categoryName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {/* {errors.categoryType && <div className="text-danger">{errors.categoryType}</div>} */}
                                                <div className='wizard-form-error' />
                                            </div>
                                        </div>
                                        <div className='col-sm-6'>
                                            <label className='form-label'>Course Name*</label>
                                            <div className='position-relative'>
                                                <input
                                                    type='text'
                                                    className='form-control wizard-required'
                                                    placeholder='Enter Course Name'
                                                    required=''
                                                    name="courseName"
                                                    value={formData.courseName}
                                                    onChange={handleChange}
                                                />
                                                {/* {errors.courseName && <div className="text-danger">{errors.courseName}</div>} */}

                                                <div className='wizard-form-error' />
                                            </div>
                                        </div>

                                        <div className='col-sm-6'>
                                            <label className='form-label'>Instructor Name</label>
                                            <div className='position-relative'>
                                                <input
                                                    type='text'
                                                    className='form-control wizard-required'
                                                    placeholder='Enter Instructor Name'
                                                    required=''
                                                    name="InstructorName"
                                                    value={formData.InstructorName}
                                                    onChange={handleChange}
                                                />
                                                <div className='wizard-form-error' />
                                            </div>
                                        </div>

                                        <div className='col-sm-6'>
                                            <label className='form-label'>Language*</label>
                                            <div className='position-relative'>
                                                <input
                                                    inputMode='none'
                                                    type='text'
                                                    className='form-control wizard-required'
                                                    required=''
                                                    name="language"
                                                    value={formData.language}
                                                    onChange={handleChange}
                                                />
                                                <div className='wizard-form-error' />
                                            </div>
                                        </div>
                                        {/* New Date and Duration Section */}
                                        <div className='col-12'>
                                            {formData.schedules.map((schedule, index) => (
                                                <div key={index} className='row g-3 mb-3'>
                                                    <div className='col-sm-6'>
                                                        <label className='form-label'>Date*</label>
                                                        <div className='position-relative'>
                                                            <input
                                                                type='date'
                                                                className='form-control wizard-required'
                                                                required=''
                                                                name="date"
                                                                min={new Date().toISOString().split('T')[0]} // Only allow future dates
                                                                value={schedule.date}
                                                                onChange={(e) => handleScheduleChange(index, 'date', e.target.value)}
                                                            />
                                                            <div className='wizard-form-error' />
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-4'>
                                                        <label className='form-label'>Duration (days)*</label>
                                                        <div className='position-relative'>
                                                            <input
                                                                type='number'
                                                                className='form-control wizard-required'
                                                                placeholder='Enter duration in days'
                                                                required=''
                                                                name="duration"
                                                                min="1"
                                                                value={schedule.duration}
                                                                onChange={(e) => handleScheduleChange(index, 'duration', e.target.value)}
                                                            />
                                                            <div className='wizard-form-error' />
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-2 d-flex align-items-end'>
                                                        {index === formData.schedules.length - 1 ? (
                                                            <button
                                                                type='button'
                                                                className='btn btn-primary'
                                                                onClick={addMoreSchedule}
                                                            >
                                                                Add More
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type='button'
                                                                className='btn btn-danger'
                                                                onClick={() => removeSchedule(index)}
                                                            >
                                                                Remove
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <div className="card">
                                                    <div className="card-header bg-light">
                                                        {/* <h5 className="mb-0">Early Bird Discount</h5> */}
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-check form-switch mb-3">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="earlyBirdToggle"
                                                                        checked={formData.hasEarlyBirdDiscount}
                                                                        onChange={(e) => handleChange({
                                                                            target: {
                                                                                name: "hasEarlyBirdDiscount",
                                                                                value: e.target.checked
                                                                            }
                                                                        })}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="earlyBirdToggle">
                                                                        Enable Early Bird Discount
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            {formData.hasEarlyBirdDiscount && (
                                                                <>
                                                                    <div className="col-md-6">
                                                                        <label className="form-label">Discount Type</label>
                                                                        <select
                                                                            className="form-select"
                                                                            name="discountType"
                                                                            value={formData.discountType}
                                                                            onChange={handleChange}
                                                                        >
                                                                            <option value="percentage">Percentage (%)</option>
                                                                            <option value="fixed">Fixed Amount (₹)</option>
                                                                        </select>
                                                                    </div>

                                                                    <div className="col-md-6 mt-3">
                                                                        <label className="form-label">
                                                                            {formData.discountType === 'percentage' ? 'Discount Percentage' : 'Discount Amount (₹)'}
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            name="discountValue"
                                                                            value={formData.discountValue}
                                                                            onChange={handleChange}
                                                                            min={0}
                                                                            max={formData.discountType === 'percentage' ? 100 : undefined}
                                                                        />
                                                                    </div>

                                                                    {/* <div className="col-md-6 mt-3">
                                                                        <label className="form-label">Discount Ends On</label>
                                                                        <input
                                                                            type="date"
                                                                            className="form-control"
                                                                            name="discountEndDate"
                                                                            value={formData.discountEndDate}
                                                                            onChange={handleChange}
                                                                            min={new Date().toISOString().split('T')[0]}
                                                                        />
                                                                    </div> */}

                                                                    <div className="col-6 mt-3">
                                                                        <div className="alert alert-info">
                                                                            <strong>Discount Preview:</strong>
                                                                            {formData.price && formData.discountValue ? (
                                                                                <>
                                                                                    <div className="mt-2">
                                                                                        Original Price: ₹{formData.price}
                                                                                    </div>
                                                                                    <div>
                                                                                        {formData.discountType === 'percentage' ? (
                                                                                            <>
                                                                                                Discount: {formData.discountValue}% (₹{(formData.price * formData.discountValue / 100).toFixed(2)})
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                Discount: ₹{formData.discountValue}
                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className="fw-bold">
                                                                                        Final Price: ₹{
                                                                                            formData.discountType === 'percentage'
                                                                                                ? (formData.price - (formData.price * formData.discountValue / 100)).toFixed(2)
                                                                                                : (formData.price - formData.discountValue).toFixed(2)
                                                                                        }
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                <div className="mt-2">Enter price and discount to see preview</div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Your existing price inputs */}
                                        <div className='col-sm-6'>
                                            <label className='form-label'>Price {"(₹)"}*</label>
                                            <div className='position-relative'>
                                                <input
                                                    type='number'
                                                    className='form-control wizard-required'
                                                    placeholder='Enter price'
                                                    required=''
                                                    name="price"
                                                    value={formData.price}
                                                    onChange={handleChange}
                                                    min="0"
                                                />
                                                <div className='wizard-form-error' />
                                            </div>
                                        </div>
                                        <div className='col-sm-6'>
                                            <label className='form-label'>Offer Price {"(₹)"}</label>
                                            <div className='position-relative'>
                                                <input
                                                    type='number'
                                                    className='form-control wizard-required'
                                                    placeholder='Enter Offer price'
                                                    name="offerPrice"
                                                    value={formData.offerPrice || ''}
                                                    onChange={handleChange}
                                                    // onChange={handleChange}
                                                    min="0"
                                                    readOnly={formData.hasEarlyBirdDiscount}
                                                />
                                                {formData.hasEarlyBirdDiscount && (
                                                    <small className="text-muted">Calculated automatically from discount</small>
                                                )}
                                                <div className='wizard-form-error' />
                                            </div>
                                        </div>
                                        <div className='col-sm-6'>
                                            <label className='form-label'>Select Location*</label>
                                            <div className='position-relative'>
                                                <select
                                                    className="form-select"
                                                    name="location"
                                                    value={formData.location}
                                                    onChange={handleChange}
                                                    disabled={isClassroom}
                                                >
                                                    <option value="">Select a Location</option>
                                                    {locations.map((category) => (
                                                        <option key={category.id} value={category.id}>
                                                            {category.location}
                                                        </option>
                                                    ))}
                                                </select>
                                                {/* {errors.categoryType && <div className="text-danger">{errors.categoryType}</div>} */}
                                                <div className='wizard-form-error' />
                                            </div>
                                        </div>
                                        <div className='col-sm-6'>
                                            <label className='form-label'>Slug</label>
                                            <div className='position-relative'>
                                                <input
                                                    type='text'
                                                    className='form-control wizard-required'
                                                    placeholder='Enter Slug'
                                                    required=''
                                                    name="slug"
                                                    value={formData.slug}
                                                    onChange={handleChange}
                                                />
                                                <div className='wizard-form-error' />
                                            </div>
                                        </div>
                                        <div className='col-sm-12'>
                                            <label className='form-label'>Short Description*</label>
                                            <div className='position-relative'>
                                                <textarea
                                                    type='text'
                                                    className='form-control wizard-required'
                                                    placeholder='Enter short description'
                                                    required=''
                                                    name="shortDescription"
                                                    value={formData.shortDescription}
                                                    onChange={handleChange}
                                                />
                                                {/* {errors.shortDescription && <div className="text-danger">{errors.shortDescription}</div>} */}

                                                <div className='wizard-form-error' />
                                            </div>
                                        </div>

                                        <div className='col-sm-12'>
                                            <div>
                                                <label className='form-label text-neutral-900'>
                                                    Description
                                                </label>
                                                <div className='border border-neutral-200 radius-8 overflow-hidden'>
                                                    <div className='height-200'>
                                                        {/* Toolbar */}
                                                        <div id='toolbar-container'>
                                                            <span className='ql-formats'>
                                                                <select className='ql-font'></select>
                                                                <select className='ql-size'></select>
                                                            </span>
                                                            <span className='ql-formats'>
                                                                <button className='ql-bold'></button>
                                                                <button className='ql-italic'></button>
                                                                <button className='ql-underline'></button>
                                                                <button className='ql-strike'></button>
                                                            </span>
                                                            <span className='ql-formats'>
                                                                <select className='ql-color'></select>
                                                                <select className='ql-background'></select>
                                                            </span>
                                                            <span className='ql-formats'>
                                                                <button className='ql-script' value='sub'></button>
                                                                <button className='ql-script' value='super'></button>
                                                            </span>
                                                            <span className='ql-formats'>
                                                                <button className='ql-header' value='1'></button>
                                                                <button className='ql-header' value='2'></button>
                                                                <button className='ql-blockquote'></button>
                                                                <button className='ql-code-block'></button>
                                                            </span>
                                                            <span className='ql-formats'>
                                                                <button className='ql-list' value='ordered'></button>
                                                                <button className='ql-list' value='bullet'></button>
                                                                <button className='ql-indent' value='-1'></button>
                                                                <button className='ql-indent' value='+1'></button>
                                                            </span>
                                                            <span className='ql-formats'>
                                                                <button className='ql-direction' value='rtl'></button>
                                                                <select className='ql-align'></select>
                                                            </span>
                                                            <span className='ql-formats'>
                                                                <button className='ql-link'></button>
                                                                <button className='ql-image'></button>
                                                                <button className='ql-video'></button>
                                                                <button className='ql-formula'></button>
                                                            </span>
                                                            <span className='ql-formats'>
                                                                <button className='ql-clean'></button>
                                                            </span>
                                                        </div>

                                                        {/* Editor */}
                                                        <ReactQuill
                                                            ref={quillRef}
                                                            theme='snow'
                                                            value={formData.description}
                                                            onChange={handleRichTextChange}
                                                            modules={modules}
                                                            formats={formats}
                                                            placeholder='Enter description...'
                                                        />
                                                        {/* {errors.description && <div className="text-danger">{errors.description}</div>} */}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-group text-end'>
                                            <button
                                                onClick={() => {
                                                    nextStep();
                                                    handleSubmit();
                                                }}
                                                type='ffff'
                                                className='form-wizard-next-btn btn btn-primary-600 px-32'
                                            >
                                                Save & Continue
                                            </button>
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset
                                    className={`wizard-fieldset ${currentStep === 2 && "show"} `}
                                >
                                    <h6 className='text-md text-neutral-500'>
                                        Curriculum Information
                                    </h6>
                                    <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-end">
                                        <div></div>
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-right gap-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#exampleModalEdit"
                                                onClick={() => {
                                                    setCurriculamForm({ name: "", serial: "" });
                                                    setIsEditMode(false);
                                                }}
                                            >
                                                <Icon
                                                    icon="ic:baseline-plus"
                                                    className="icon text-xl line-height-1"
                                                />
                                                Add Module
                                            </button>
                                        </div>

                                    </div>
                                    <div className="table-responsive scroll-sm">
                                        <table className="table bordered-table sm-table mb-0 align-items-center">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Serial</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {curriculamData.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>
                                                            <div className="d-flex align-items-center gap-10">
                                                                <div className="form-check style-check d-flex align-items-center">

                                                                </div>
                                                                {String(index + 1).padStart(2, "0")}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <span className="text-md mb-0 fw-normal text-secondary-light">
                                                                {item.tittle}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                                <button
                                                                    type="button"
                                                                    className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#addModalEdit"
                                                                    onClick={() => setSelectedCategory(item)}
                                                                >
                                                                    <Icon
                                                                        icon="majesticons:eye-line"
                                                                        className="icon text-xl"
                                                                    />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#exampleModalEdit"
                                                                    onClick={() => handleEditClick(item)}
                                                                >
                                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                    onClick={() => handleDeleteCurri(item)}
                                                                >
                                                                    <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <br></br>
                                    <div className='form-group d-flex align-items-center justify-content-end gap-8'>
                                        <button
                                            onClick={prevStep}
                                            type='button'
                                            className='form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32'
                                        >
                                            Back
                                        </button>
                                        <button
                                            onClick={editDatas ? nextStep : navagatoFun}
                                            type='submit'
                                            className='form-wizard-next-btn btn btn-primary-600 px-32'
                                        >
                                            {editDatas ? "Save & Continue " : "Save"}
                                        </button>
                                    </div>

                                </fieldset>
                                {editDatas &&
                                    <fieldset
                                        className={`wizard-fieldset ${currentStep === 3 && "show"} `}
                                    >
                                        <h6 className='text-md text-neutral-500'>Review Information</h6>
                                        <div className='row gy-3'>
                                            <div className="table-responsive scroll-sm">
                                                <table className="table bordered-table sm-table mb-0 align-items-center">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">S.No</th>
                                                            <th scope="col">Course Name</th>
                                                            <th scope="col" style={{ minWidth: "250px", whiteSpace: "nowrap" }}>Feedback</th>
                                                            <th scope="col">Status</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {reviewData.map((item, index) => (
                                                            <tr key={item.id}>
                                                                <td>{index + 1}</td>
                                                                <td>
                                                                    <span className="text-md mb-0 fw-normal text-secondary-light">
                                                                        {item.courseName}
                                                                    </span>
                                                                </td>
                                                                <td style={{ maxWidth: "250px", wordBreak: "break-word" }}>
                                                                    <span className="text-md mb-0 fw-normal text-secondary-light d-inline-block ">
                                                                        {item.feedback}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <div className="text-center">
                                                                        <button
                                                                            className="btn px-18 py-11 text-primary-light"
                                                                            type="button"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false"
                                                                        >
                                                                            <Icon icon="entypo:dots-three-vertical" className="menu-icon" />
                                                                        </button>
                                                                        <ul className="dropdown-menu">
                                                                            {["Active", "Inactive", "None"].map(status => (
                                                                                <li key={status}>
                                                                                    <Link
                                                                                        className={`dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 
                        ${item.status === status ? "bg-primary-600 text-white" : ""}`}
                                                                                        to="#"
                                                                                        onClick={() => handleStatusChange(item.id, status)}
                                                                                    >
                                                                                        {status}
                                                                                    </Link>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className='form-group d-flex align-items-center justify-content-end gap-8'>
                                                <button
                                                    onClick={prevStep}
                                                    type='button'
                                                    className='form-wizard-previous-btn btn btn-neutral-500 border-neutral-100 px-32'
                                                >
                                                    Back
                                                </button>
                                                <button
                                                    onClick={navagatoFun}
                                                    type='submit'
                                                    className='form-wizard-next-btn btn btn-primary-600 px-32'
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </fieldset>
                                }

                            </div>
                        </div>
                        {/* Form Wizard End */}
                    </div>
                </div>
            </div>

            {/* Model */}
            <div
                className="modal fade"
                id="exampleModalEdit"
                tabIndex={-1}
                aria-labelledby="exampleModalEditLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                                {isEditMode ? "Edit Module" : " Create Module"}
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-24">
                            <div>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label"> Name </label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            value={curriculamForm.name}
                                            onChange={handleChangeForModul}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label">Serial</label>
                                        <input
                                            type="number"
                                            name="serial"
                                            className="form-control"
                                            value={curriculamForm.serial}
                                            onChange={handleChangeForModul}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <button type="submit" className="btn btn-primary text-sm" onClick={handleCurriculamSubmit}>
                                            {isEditMode ? "Update" : "Submit"}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* Category Modal */}
            <ToastContainer />

            <DynamicModal selectedCategory={selectedCategory} getSubtitle={getSubtitle} fetchCurriculum={fetchCurriculum} />
        </div>


    )
}

export default CoursePageLayer